export default "__VITE_ASSET__DOTtHtaO__"